<template>
	<ManagingSection class="ai" :is-table="true">
		<template slot="infoSection">
			<div class="section__info__left">등록: {{ totalCount }}건</div>
			<div class="section__info__right">
				<button
					class="btn orange section__ifno__items"
					@click="allNormal"
				>
					리뷰 정상 일괄 변경
				</button>
				<button
					class="btn orange section__info__items"
					@click="allBlind"
				>
					리뷰 블라인드 일괄 변경
				</button>
				<button
					class="btn orange section__info__items"
					@click="allAnalysis"
				>
					분석 일괄 확인
				</button>
			</div>
		</template>
		<table class="table-main">
			<thead>
				<tr>
					<th class="list__checkbox-item">
						<input
							v-model="allCheckModel"
							:value="allCheck"
							type="checkbox"
						/>
					</th>
					<th>항번</th>
					<th>닉네임</th>
					<th>브랜드</th>
					<th>제품명</th>
					<th>리뷰 내용</th>
					<th>리뷰 작성일</th>
					<th>리뷰 수정일</th>
					<th>AI 검수상태</th>
					<th>AI 부적합 사유</th>
					<th>현재 리뷰 상태</th>
					<th>리뷰 상태</th>
					<th>블라인드 사유</th>
					<th>AI 분석 확인</th>
				</tr>
			</thead>
			<tbody>
				<tr
					:class="['ai__table', data.isProcessed && 'ai__confirm']"
					v-for="data in aiList"
					:key="data.id"
				>
					<td>
						<input
							v-model="itemCheck"
							:value="data.id"
							type="checkbox"
							:disabled="data.isProcessed"
						/>
					</td>
					<td>{{ data.id }}</td>
					<td>
						<RouterLink
							:to="`/register/register-info/${data.register.idRegister}`"
							class="link"
						>
							{{
								(data.register && data.register.nickName) || '-'
							}}
						</RouterLink>
					</td>
					<td>
						{{ data.review.product.brand.brandTitle || '-' }}
					</td>
					<td>
						{{ data.review.product.productTitle || '-' }}
					</td>
					<td class="ai__reviewText">
						<RouterLink
							:to="`/review/${data.review.id}`"
							class="link"
						>
							{{ data.review.text || '-' }}
						</RouterLink>
					</td>
					<td>{{ data.review.createDate }}</td>
					<td>{{ data.review.modifiedDate }}</td>
					<td
						:class="[
							'ai__inspection',
							data.analysis.inspectionState === '부적합'
								? 'ai__invalid'
								: 'ai__checked',
						]"
					>
						{{ data.analysis.inspectionState }}
					</td>
					<td>
						{{ data.matchedCause || '관리자가 직접 검수 필요' }}
					</td>
					<td>{{ data.reviewState }}</td>
					<td class="ai__reviewStatus">
						<RadioList
							:key="data.id + data.reviewStatus"
							:radio-list="reviewStatusList"
							v-model="data.reviewStatus"
							@input="handleReviewStatusChange(data)"
							:disabled="
								data.isProcessed ||
								data.reviewState === '블라인드'
									? 'all'
									: ''
							"
						/>
					</td>
					<td class="ai__blindCause">
						<Selector
							v-model="data.blindCause[0]"
							:option-list="blindCauseList"
							:disabled="
								data.reviewStatus === 'N' ||
								data.isProcessed ||
								data.reviewState === '블라인드'
							"
							@input="blindCauseChange(data)"
						/>
						<Selector
							v-model="data.blindCause[1]"
							:option-list="
								getBlindCauseList2(data.blindCause[0])
							"
							:disabled="
								data.reviewStatus === 'N' || !data.blindCause[0]
							"
						/>
					</td>
					<td>
						<button
							class="btn"
							:disabled="data.isProcessed"
							@click="singleAnalysis(data)"
						>
							확인
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			slot="pagination"
			:totalItem="totalCount"
			:limit="limit"
			:offset="offset"
			@to="paging($event.offset)"
		/>
	</ManagingSection>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import RadioList from '@/components/RadioList.vue';
	import Selector from '@/components/Selector';
	import { mapState } from 'vuex';
	import { formattedDate } from '../../util';
	import dayjs from 'dayjs';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		components: {
			ManagingSection,
			RadioList,
			Selector,
			PaginationBox,
		},
		computed: {
			...mapState({
				causeList: state => state.notice.causeList,
			}),
			blindCauseList() {
				return [
					{ value: null, name: '사유를 선택하세요' },
					...(this.causeList || []),
				];
			},
			allCheckModel: {
				get() {
					const enabledIds = this.aiList
						.filter(data => !data.isProcessed)
						.map(data => data.id);
					return (
						enabledIds.length > 0 &&
						enabledIds.every(id => this.itemCheck.includes(id))
					);
				},
				set(checked) {
					if (checked) {
						this.itemCheck = this.aiList
							.filter(data => !data.isProcessed)
							.map(data => data.id);
					} else {
						this.itemCheck = [];
					}
				},
			},
		},
		data() {
			return {
				reviewStatusList: [
					{ id: 'N', value: '정상' },
					{ id: 'B', value: '블라인드' },
					{ id: 'C', value: '검수중' },
				],
				reviewStatus: 1,
				reportTypeList: [],
				limit: 50,
				offset: 0,
				aiList: [],
				totalCount: 0,
				allCheck: false,
				itemCheck: [],
			};
		},
		methods: {
			blindCauseChange(data) {
				data.blindCause[1] = null;
			},
			async getBlindCauseList() {
				await this.$store.dispatch('notice/init');
			},
			allNormal() {
				if (this.itemCheck.length === 0) {
					alert('선택된 항목이 없습니다.');
					return;
				}
				alert(
					'리뷰 정상 일괄 변경후 분석 일괄 확인까지 눌러주셔야 반영이 됩니다'
				);
				this.aiList.forEach(item => {
					const isChecked = this.itemCheck.includes(item.id);
					const isNotProcessed = !item.isProcessed;
					if (isChecked && isNotProcessed) {
						item.reviewStatus = 'N';
						item.blindCause = [null, null];
					}
				});
			},
			allBlind() {
				if (this.itemCheck.length === 0) {
					alert('선택된 항목이 없습니다.');
					return;
				}
				alert(
					'블라인드 일괄 변경후 분석 일괄 확인까지 눌러주셔야 반영이 됩니다'
				);

				this.aiList.forEach(item => {
					const isChecked = this.itemCheck.includes(item.id);
					const isNotProcessed = !item.isProcessed;
					if (isChecked && isNotProcessed) {
						item.reviewStatus = 'B';
						if (!Array.isArray(item.blindCause)) {
							this.$set(item, 'blindCause', [null, null]);
						}
						item.blindCause[0] = item.analysis.blind.id ?? null;
					}
				});
			},
			allAnalysis() {
				if (this.itemCheck.length === 0) {
					alert('선택된 항목이 없습니다.');
					return;
				}
				const params = this.getParams();
				this.confirmAnalysis(params);
			},
			singleAnalysis(data) {
				const params = this.reviewInspectionItem(data);
				this.confirmAnalysis([params]);
			},
			handleReviewStatusChange(data) {
				const blindId = data.analysis?.blind?.id ?? null;

				if (
					(data.reviewStatus === 'B' || data.reviewStatus === 'C') &&
					!data.blindCause[0]
				) {
					const firstRealCause = this.causeList.find(
						cause => cause.value === blindId
					);
					if (!Array.isArray(data.blindCause)) {
						this.$set(data, 'blindCause', [null, null]);
					}
					data.blindCause[0] = firstRealCause?.value ?? null;
				}
				if (data.reviewStatus === 'N') {
					data.blindCause = [null, null];
				}
			},
			formatDay(date) {
				const formattedDate = dayjs(date).format('YYYY-MM-DD');
				return formattedDate;
			},
			getBlindCauseList2(firstCause) {
				return firstCause
					? this.blindCauseList.filter(
							({ value }) => value !== firstCause
						)
					: this.blindCauseList;
			},
			async paging(offset = 0) {
				this.offset = offset;
				await this.getAiList();
			},
			async getAiList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/review-inspection?offset=${this.offset}&limit=${this.limit}`
					);

					this.aiList = data.reviewInspectionList.map((item, idx) => {
						const blindId = item.analysis?.blind?.id ?? null;
						const matchedCause =
							this.causeList?.find(
								cause => cause.value === blindId
							)?.name ?? null;
						return {
							...item,
							review: {
								...item.review,
								createDate: formattedDate(
									String(item.review.createDate)
								),
								modifiedDate:
									item.review.createDate !==
									item.review.modifiedDate
										? formattedDate(
												String(item.review.modifiedDate)
											)
										: '-',
							},
							createdAt: this.formatDay(item.createdAt),
							updatedAt: this.formatDay(item.updatedAt),
							reviewState:
								item.review.state === 'B'
									? '블라인드'
									: item.review.state === 'C'
										? '검수중'
										: '정상',
							reviewStatus: item.review.state || 'N',
							blindCause: [null, null],
							matchedCause: matchedCause,
							isProcessed: item.processedAt ? true : false,
						};
					});
					this.totalCount = data.totalCount;
				} catch (error) {
					console.error(error);
				}
			},
			validation(data) {
				const cause = data.blindCause;
				if (
					['B', 'C'].includes(data.reviewStatus) &&
					(!cause || !cause.filter(Boolean).length)
				) {
					alert('블라인드 사유를 선택해 주세요.');
					return false;
				}
				return true;
			},
			reviewInspectionItem(data) {
				if (!this.validation(data)) {
					return null;
				}

				const item = {
					id: data.id,
					review: {
						id: data.review.id,
						state: data.reviewStatus,
					},
				};

				if (data.reviewStatus === 'B' || data.reviewStatus === 'C') {
					item['blindIdList'] = [
						data.blindCause[0],
						data.blindCause[1],
					].filter(cause => cause !== null);
				}

				return item;
			},
			getParams() {
				return this.aiList
					.filter(data => this.itemCheck.includes(data.id))
					.map(data => this.reviewInspectionItem(data))
					.filter(Boolean);
			},
			async confirmAnalysis(paramsList) {
				try {
					const review = {};
					for (const item of paramsList) {
						const key = item.review.id;

						const exisiting = review[key];

						if (!exisiting || item.id > exisiting.id) {
							review[key] = item;
						}
					}

					const uniqueParams = Object.values(review);

					const stateSet = new Set(
						uniqueParams.map(item => item.review.state)
					);

					let alertMessage = '';
					if (stateSet.size === 1 && stateSet.has('N')) {
						alertMessage = '정상 처리되었습니다';
					} else if (
						stateSet.size === 1 &&
						(stateSet.has('B') || stateSet.has('C'))
					) {
						alertMessage = '블라인드 처리되었습니다';
					} else {
						alertMessage = '변경처리 되었습니다';
					}

					const params = {
						reviewInspectionList: uniqueParams,
					};
					await this.$axiosAdmin2.post(
						'/api/review-inspection/state',
						params
					);
					alert(alertMessage);
					await this.getAiList();
				} catch (error) {
					console.error(error);
				}
			},
		},
		created() {
			if (!this.causeList) {
				this.getBlindCauseList();
			}
			this.getAiList();
		},
	};
</script>
<style lang="scss" scoped>
	.ai {
		&__reviewText {
			width: 400px;
		}
		&__reviewStatus {
			width: 150px;
		}
		&__blindCause {
			width: 200px;
		}
		&__inspection {
			&.ai__checked {
				color: $font-blue;
			}
			&.ai__invalid {
				color: $red;
			}
		}
		&__table {
			&.ai__confirm {
				background-color: lightgray;
			}
		}
		&__autoProcess {
			color: $green;
		}
	}
</style>
